import create from 'zustand';

interface OpenChatOptions {
  psychologyMode?: boolean;
}

interface CaissaChatState {
  openRequestId: number;
  openRequestPsychologyMode: boolean;
  openChat: (opts?: OpenChatOptions) => void;
}

// Transient signal only — no persist middleware, this should not survive reload.
export const useCaissaChatStore = create<CaissaChatState>(set => ({
  openRequestId: 0,
  openRequestPsychologyMode: false,
  openChat: opts =>
    set(state => ({
      openRequestId: state.openRequestId + 1,
      openRequestPsychologyMode: !!opts?.psychologyMode,
    })),
}));

export default useCaissaChatStore;
